import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { faClose } from '@fortawesome/pro-light-svg-icons';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import TrueImpactIconButton from 'shared/design-system/components/TrueImpactIconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/pro-light-svg-icons';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface CNSupportFooterProps {
  isThirdParty: boolean;
}

const StyledDiv = styled.div`
  background-color: #f5f5f5;
  border-top: 1px solid #e0e0e0;
  bottom: 0;
  color: #666;
  font-size: 14px;
  left: 0;
  padding: 12px 20px;
  position: fixed;
  right: 0;
  text-align: center;
  z-index: 100;
  padding-left: 40px;
  .close-icon {
    margin-left: ${SPACERS.small};
    background-color: #cccccc;
    transition: background-color 0.5s ease;
  }
`;

const StyledSupportButton = styled.button`
  position: fixed;
  bottom: ${SPACERS.medium};
  right: ${SPACERS.medium};
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.cnBlue};
  transition: background-color 0.5s ease;
  &:hover {
    background-color: ${COLORS.brandPrimary};
  }
  .support-button {
    color: ${COLORS.whiteBase};
    path {
      fill: ${COLORS.whiteBase};
    }
  }
`;

const CNSupportFooter: React.FC<CNSupportFooterProps> = ({ isThirdParty }) => {
  const [visible, setVisible] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setVisible(true);
  }, [setVisible]);

  const handleClose = useCallback(() => {
    setVisible(false);
  }, [setVisible]);

  if (!isThirdParty) return null;

  if (!visible) {
    return (
      <StyledSupportButton onClick={handleOpen}>
        <FontAwesomeIcon
          size="2x"
          icon={faCircleQuestion}
          color={COLORS.whiteBase}
          className="support-button"
        />
      </StyledSupportButton>
    );
  }

  return (
    <StyledDiv className="cn-support-footer">
      Questions? Please reach out to{' '}
      <a href="mailto:impactreportsupport@trueimpact.com">
        impactreportsupport@trueimpact.com
      </a>
      <TrueImpactIconButton
        icon={faClose}
        className="close-icon"
        onClick={handleClose}
      />
    </StyledDiv>
  );
};

export default CNSupportFooter;
